export enum SubscriptionFrequencyTypeEnum {
  EVERY_N_DAYS = "every_n_days",
}
